import { BrokenLinkIcon } from '@shared/ui/icons';
import { GaugeIcon, SearchIcon } from '@shared/ui/icons/nav';

import { SystemLinkAction } from '../_shared/components';
import { ErrorPage } from '../_shared/ErrorPage';
import { copy } from './copy';

/**
 * The fall-through surface for an operator URL that names no console surface.
 *
 * It carries the **whole** shell — the navigation handle, the lockup, the search
 * field, the theme toggle, the notification control, the create action, the
 * account menu, the seventeen-entry column, and the footer. Nothing is stripped
 * for being «just an error page», and the reason is the inverse of the
 * intuition: this is the surface where an operator most needs a way out, so it
 * carries the densest exit the area owns rather than the sparsest.
 *
 * Two things the shell deliberately does **not** do here. No entry carries
 * `aria-current` — the URL the operator landed on is not a destination in the
 * column, and lighting the nearest one would announce a location the reader is
 * not at. And no breadcrumb is drawn, for the same reason: there is no position
 * in the sitemap to state.
 *
 * The icon is the broken ring the two sibling packs already draw. The state is
 * identical across the three areas — a link that no longer arrives — and a third
 * shape for one state would be variation without a difference. It stays muted: a
 * 404 is an absence, not a fault, and the failure colour is reserved for failure.
 */
export function NotFoundPage() {
  return (
    <ErrorPage
      kind="notfound"
      documentTitle={copy.documentTitle}
      icon={<BrokenLinkIcon />}
      heading={copy.heading}
      body={copy.body}
      actions={
        <>
          <SystemLinkAction to="/" intent="primary" icon={<GaugeIcon />}>
            {copy.actions.home}
          </SystemLinkAction>
          <SystemLinkAction to="/content" intent="secondary" icon={<SearchIcon />}>
            {copy.actions.content}
          </SystemLinkAction>
        </>
      }
    />
  );
}
